export default __webpack_public_path__ + "static/media/background.0e825030.jpg";